import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '../../../../../Typography/Typography';
export const Title = ({ title }) => {
    if (!title)
        return _jsx("div", {});
    if (typeof title === 'string')
        return _jsx(Typography.Text, { children: title });
    return title;
};
